import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Signup from '../app/views/pages/signup'
import { ProtectedRoute } from '../app/views/components/protected-pages-components/+protected-route'
import { NotFoundPage } from '../app/views/pages/error/+not-found-page'
import ProfilePage from '../app/views/pages/profile/+profile-page'
import UsersPage from '../app/views/pages/users/+users-page'
import UserManagementPage from 'app/views/pages/user-management/+user-management-page'
import { ReportingPage } from 'app/views/pages/reports/+reports_page'
import SingleTradeAssignmentPage from 'app/views/pages/trade-closing/single-trade-assignment/+single-trade-assignment-page'
import IndexRateOptionManagementPage from 'app/views/pages/index-rate-options-management/+iro-management-page'
import FeesPage from 'app/views/components/Fees/+manage-fees-facility-page'
import HolidayCalendarsPage from 'app/views/pages/holiday-calendars/+holiday-calendars-page'
import SimulationsPage from 'app/views/pages/simulations/+simulations_page'
import JobManagementPage from 'app/views/pages/job-management/+job-management-page'
import InterestPaymentSchedulePage from 'app/views/components/interest-payment-schedule/+manage-interest-payment-page'
import PIKSchedulerPage from 'app/views/components/pik-scheduler/+manage-pik-page'
import NoticePreview from 'app/views/pages/release-queue/notices/preview/+notice-preview-page'
import { MyWorkLandingPage } from 'app/views/pages/mywork/+mywork_landing_page'
import { PositionsLandingPage } from 'app/views/pages/positions/+positions_landing_page'
import { EntityLandingPage } from 'app/views/pages/accounts-management/entities/entity-details/+entity_landing_page'
import { DealManagmentPage } from 'app/views/pages/deals-management/deals-management-landing-components/+deals-management-page'
import DealsContentPage from 'app/views/pages/deals-management/deals/deals-management'
import FacilitiesContentPage from 'app/views/pages/deals-management/facilities/facilities-content-page'
import { LockedDealManagmentPage } from 'app/views/pages/deals-management/deals-management-landing-components/+locked-deals-management-page'
import { PricingGridPage } from 'app/views/pages/deals-management/pricing-grid/+pricing-grid-page'
import { DealFeesPage } from 'app/views/pages/deals-management/deal-fees/+deal-fees-page'
import BorrowersPage from 'app/views/pages/deals-management/facilities/facility-details/+borrowers-page'
import BorrowersPageDeal from 'app/views/pages/deals-management/deals/deal-details/+borrowers-deal-page'
import GuarantorsPageDeal from 'app/views/pages/deals-management/deals/deal-details/+guarantors-deal-page'
import { ReleaseQueueLandingPage } from 'app/views/pages/release-queue/release-queue-landing-pages/+release_queue_landing_page'
import { LockedReleaseQueueLandingPage } from 'app/views/pages/release-queue/release-queue-landing-pages/+locked_release_queue_landing_page'
import { ServicingLandingPage } from 'app/views/pages/servicing/+servicing_landing_page'
import { ServicingPageData } from 'app/views/pages/servicing/servicing-page-data'
import { TradeClosingLandingPage } from 'app/views/pages/trade-closing/+trade-closing-landing-page'
import { DealLandingPage } from 'app/views/pages/deals-management/deals/deal-details/+deal-landing-page'
import DealPage from 'app/views/pages/deals-management/deals/deal-details/deal-page'
import NotesPage from 'app/views/components/notes-and-attachment/notes-page'
import AttachmentsPage from 'app/views/components/notes-and-attachment/attachments-page'
import { FacilityLandingPage } from 'app/views/pages/deals-management/facilities/facility-details/+facility-landing-page'
import FacilityPage from 'app/views/pages/deals-management/facilities/facility-details/facility-page'
import FacilityHistoryPage from 'app/views/pages/deals-management/facilities/facility-details/history/facility-history-page'
import LoansPage from 'app/views/pages/deals-management/loans/facility-loans/loans-page'
import FacilityLocContent from 'app/views/pages/deals-management/letter-of-credit/facility-loc/locs-page'
import EntitiesManagementPage from 'app/views/pages/accounts-management/entities/+entities-management-page'
import { LenderAllocationsLandingPage } from 'app/views/pages/deals-management/lender-allocations/+lender-allocations-landing-page'
import { LenderAllocationsFundPanel, LenderAllocationsFundManagerPanel } from 'app/views/pages/deals-management/lender-allocations/lender-allocations-drill-page'
import EntitiesProfilePage from 'app/views/pages/accounts-management/entities/entity-profile/+entities-profile-page'
import { AmortizationLandingPage } from 'app/views/components/amortization-scheduler/+amortization-schedule-landing-page'
import EntitiesTypePage from 'app/views/pages/accounts-management/entities/entity-type/+entities-type-page'
import PortfoliosAndStrategiesPage from 'app/views/pages/accounts-management/portfolios-and-strategies/+portfolios-and-strategies-page'
import { TradeManagementLandingPage } from 'app/views/pages/trade-entry/+trade-management-landing-page'
import { TradeCreateLandingPage } from 'app/views/pages/trade-entry/+trade-create-landing-page'
import { DetailTradeLandingPage } from 'app/views/pages/trade-entry/detail-trade/+detail-trade-landing-page'
import { OverviewTradeEntry } from 'app/views/pages/trade-entry/detail-trade/overview/overview-trade-entry'
import { SubTradeEntry } from 'app/views/pages/trade-entry/detail-trade/sub-trades/sub-trade-entry'
import { DocumentTradeEntry } from 'app/views/pages/trade-entry/detail-trade/documents/document-trade-entry'
import { ActivityStreamTradeEntry } from 'app/views/pages/trade-entry/detail-trade/activity-stream/activity-stream-trade-entry'
import { READ_USERS_PERMISSION } from 'app/hooks/useHasPermission'


export function RightPedalRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/mywork" replace={true} />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/profile"
          element={<ProtectedRoute component={ProfilePage} />}
        />
        <Route
          path="/users"
          element={<ProtectedRoute component={UsersPage} />}
        />
        <Route
          path="/mywork"
          element={<ProtectedRoute component={MyWorkLandingPage} />}
        >
          <Route index element={null} />
          <Route path="todo" element={null} />
          <Route path="payments" element={null} />
          <Route path="unscheduled" element={null} />
          <Route path="scheduled" element={null} />
        </Route>
        <Route
          path="/entityprofile"
          element={<ProtectedRoute component={EntitiesProfilePage} tab="entityprofile" />}
        />
        <Route
          path="/entitytype"
          element={<ProtectedRoute component={EntitiesTypePage} tab="entitytype" />}
        />
        <Route
          path="/portfolioandstrategy"
          element={<ProtectedRoute component={PortfoliosAndStrategiesPage} />}
        >
          <Route path="portfolio" element={null} />
          <Route path="strategy" element={null} />
        </Route>
        <Route
          path="/entitymanagement"
          element={<ProtectedRoute component={EntitiesManagementPage} tab='entities' />}
        />
        <Route
          path="/entitymanagement/entity/:entityId/:status"
          element={<ProtectedRoute component={EntityLandingPage} tab="entityBase" />}
        />
        <Route
          path="/entitymanagement/entity/:entityId/:status/notes"
          element={<ProtectedRoute component={EntityLandingPage} tab='entityNotes' />}
        />
        <Route
          path="/entitymanagement/entity/:entityId/:status/attachments"
          element={<ProtectedRoute component={EntityLandingPage} tab='entityAttachments' />}
        />
        <Route
          path="/entitymanagement/contacts/:entityId/:status"
          element={<ProtectedRoute component={EntityLandingPage} tab="entityContacts" />}
        />
        <Route
          path="/entitymanagement/wireinstructions/:entityId/:status"
          element={<ProtectedRoute component={EntityLandingPage} tab="entityWI" />}
        />
        <Route
          path="/entitymanagement/positions/:entityId/:status"
          element={<ProtectedRoute component={EntityLandingPage} tab="entityPositions" />}
        />
        <Route
          path="/positions"
          element={<ProtectedRoute component={PositionsLandingPage} />}
        >
          <Route index element={null} />
          <Route path="deal" element={null} />
          <Route path="facility" element={null} />
          <Route path="entity" element={null} />
        </Route>
        <Route
          path="/dealmanagement/deal/:dealId/:status"
          element={<ProtectedRoute component={DealLandingPage} />}
        >
          <Route index element={<DealPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="attachments" element={<AttachmentsPage />} />
        </Route>
        <Route
          path="/dealmanagement/deal/:dealId/:status/pricing-grid"
          element={<ProtectedRoute component={PricingGridPage} />}
        />
        <Route
          path="/dealmanagement/deal/:dealId/:status/fees/:feeType"
          element={<ProtectedRoute component={DealFeesPage} />}
        />
        <Route
          path="/dealmanagement/facilities/:facilityId/:status"
          element={<ProtectedRoute component={FacilityLandingPage} />}
        >
          <Route index element={<FacilityPage />} />
          <Route path="loans" element={<LoansPage />} />
          <Route path="locs" element={<FacilityLocContent />} />
          <Route path="history" element={<FacilityHistoryPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="attachments" element={<AttachmentsPage />} />
        </Route>
        <Route
          path="/dealmanagement/:contractType/:contractId/:status/lenders"
          element={<ProtectedRoute component={LenderAllocationsLandingPage} />}
        >
          <Route index element={<LenderAllocationsFundPanel />} />
          <Route path="fund-manager" element={<LenderAllocationsFundManagerPanel />} />
        </Route>

        <Route
          path="/dealmanagement/facilities/:facilityId/:status/fees"
          element={<ProtectedRoute component={FeesPage} />}
        />
        <Route
          path="/dealmanagement/facilities/:facilityId/:status/fees/:feeType"
          element={<ProtectedRoute component={FeesPage} />}
        />
        <Route
          path="/dealmanagement/facilities/:facilityId/:status/amortization-schedule"
          element={<ProtectedRoute component={AmortizationLandingPage} />}
        >
          <Route index element={null} />
          <Route path="history" element={null} />
        </Route>
        <Route
          path="/dealmanagement/facilities/:facilityId/:status/:loanId/:loanStatus/interest-payment-schedule"
          element={<ProtectedRoute component={InterestPaymentSchedulePage} />}
        >
          <Route index element={null} />
          <Route path="history" element={null} />
        </Route>
        <Route
          path="/dealmanagement/facilities/:facilityId/:status/pik-schedule"
          element={<ProtectedRoute component={PIKSchedulerPage} />}
        >
          <Route index element={null} />
          <Route path="history" element={null} />
        </Route>
        <Route
          path="/dealmanagement/facilities/:facilityId/borrowers"
          element={<ProtectedRoute component={BorrowersPage} />}
        />
        <Route
          path="/dealmanagement/deal/:dealId/borrowers"
          element={<ProtectedRoute component={BorrowersPageDeal} />}
        />
        <Route
          path="/dealmanagement/deal/:dealId/guarantors"
          element={<ProtectedRoute component={GuarantorsPageDeal} />}
        />
        <Route
          path="/dealmanagement"
          element={<ProtectedRoute component={DealManagmentPage} />}
        >
          <Route index element={<DealsContentPage />} />
          <Route path="facilities" element={<FacilitiesContentPage />} />
        </Route>
        <Route
          path="/dealmanagement/terminated"
          element={<ProtectedRoute component={LockedDealManagmentPage} tab="dealsLocked" />}
        />
        <Route
          path="/dealmanagement/facilities/terminated"
          element={<ProtectedRoute component={LockedDealManagmentPage} tab="facilitiesLocked" />}
        />
        <Route
          path="/releasequeue"
          element={<ProtectedRoute component={ReleaseQueueLandingPage} tab="releaseQueuePayments" />}
        />
        <Route
          path="/releasequeue/notices"
          element={<ProtectedRoute component={ReleaseQueueLandingPage} tab="releaseQueueNotices" />}
        />
        <Route
          path="/releasequeue/archived"
          element={<ProtectedRoute component={LockedReleaseQueueLandingPage} tab="lockedReleaseQueuePayments" />}
        />
        <Route
          path="/releasequeue/notices/archived"
          element={<ProtectedRoute component={LockedReleaseQueueLandingPage} tab="lockedReleaseQueueNotices" />}
        />
        <Route
          path="/releasequeue/notice-preview/:id"
          element={<ProtectedRoute component={NoticePreview} />}
        />
        <Route
          path="/assetservicing"
          element={<ProtectedRoute component={ServicingLandingPage} />}
        >
          <Route index element={<ServicingPageData key="all" />} />
          <Route path="scheduled" element={<ServicingPageData key="scheduled" tab="scheduled" />} />
          <Route path="unscheduled" element={<ServicingPageData key="unscheduled" tab="unscheduled" />} />
        </Route>
        <Route
          path="/tradeentry"
          element={<ProtectedRoute component={TradeManagementLandingPage} tab='tradeEntry' />}
        />
        <Route
          path="/tradeentry/:tradeId"
          element={<ProtectedRoute component={DetailTradeLandingPage} />}
        >
          <Route index element={<OverviewTradeEntry />} />
          <Route path="subtrade" element={<SubTradeEntry />} />
          <Route path="documents" element={<DocumentTradeEntry />} />
          <Route path="activity" element={<ActivityStreamTradeEntry />} />
        </Route>
        <Route
          path="/tradeentry/create"
          element={<ProtectedRoute component={TradeCreateLandingPage} tab='tradeEntryCreation' />}
        />
        <Route
          path="/tradeclosing"
          element={<ProtectedRoute component={TradeClosingLandingPage} />}
        >
          <Route index element={null} />
          <Route path="parent" element={null} />
          <Route path="subtrade" element={null} />
        </Route>
        <Route
          path="/tradeclosing/new-assignment"
          element={<ProtectedRoute component={SingleTradeAssignmentPage} />}
        />
        <Route
          path="/tradeclosing/assignment/:status/:id"
          element={<ProtectedRoute component={SingleTradeAssignmentPage} />}
        />
        <Route
          path="/reports"
          element={<ProtectedRoute component={ReportingPage} />}
        />
        <Route
          path="/usermanagement"
          element={<ProtectedRoute component={UserManagementPage} permissionRequired={READ_USERS_PERMISSION} />}
        />
        <Route
          path="/indexrateoptions"
          element={<ProtectedRoute component={IndexRateOptionManagementPage} />}
        />
        <Route
          path="/holidaycalendars"
          element={<ProtectedRoute component={HolidayCalendarsPage} />}
        />
        <Route
          path="/simulations"
          element={<ProtectedRoute component={SimulationsPage} />}
        />
        <Route
          path="/jobmanagement"
          element={<ProtectedRoute component={JobManagementPage} />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}